import React from 'react';
import SEO from '@components/SEO';
import styles from './index.module.css';

const IndexPage = () => (
    <div className={styles.container}>
        <SEO
            title="Hello"
            keywords={[
                'software engineer',
                'düsseldorf',
                'javascript',
                'frontend'
            ]}
            description="Personal website of Malte Wessel, Software Engineer, Düsseldorf."
        />
        <p>
            Hello, my name is Malte, I’m a <strong>Software Engineer</strong>{' '}
            currently working at trivago in Düsseldorf.
        </p>
        <p>
            I am specialized in <strong>frontend technologies</strong>,
            especially JavaScript. I love planning, implementing and maintaining
            digital products.
        </p>
    </div>
);

export default IndexPage;
